module.exports = __webpack_public_path__ + "static/media/wirepackage-colour.c88ecbf4.png";